// extracted by mini-css-extract-plugin
export default {"base":"l6g7EA","cover":"bSo569","coverImage":"MUhOTn","play":"uyjIL3","baseMobile":"b_f6Uo"};